import { buildProps as i, definePropType as e } from "./index601.js";
const t = i({
  /**
   * @description To specify the array of hours that cannot be selected
   */
  disabledHours: {
    type: e(Function)
  },
  /**
   * @description To specify the array of minutes that cannot be selected
   */
  disabledMinutes: {
    type: e(Function)
  },
  /**
   * @description To specify the array of seconds that cannot be selected
   */
  disabledSeconds: {
    type: e(Function)
  }
}), s = i({
  visible: Boolean,
  actualVisible: {
    type: Boolean,
    default: void 0
  },
  format: {
    type: String,
    default: ""
  }
});
export {
  t as disabledTimeListsProps,
  s as timePanelSharedProps
};
